










import { Component, Prop, Vue } from 'vue-property-decorator';
import Logo from './logo.vue';
import AgMenu from './menu.vue';
import {QChip} from 'quasar';

@Component({ components: { Logo, AgMenu, QChip} })
export default class Header extends Vue {
    @Prop()
    private msg!: string;
}
